module.exports = "/static/assets/a2cb93db49d1d47f17fc38f9d76eaa7a.png";